/**
 * SettingsSyncBanner — banner discreto que aparece en el top de la app
 * cuando el fetch de /store-settings falló repetidamente (>3 reintentos).
 * Copy elegido: "Sincronizando últimos precios..." — profesional, no
 * asusta al cliente (evitamos "Modo offline" a propósito).
 *
 * Mientras el banner está visible, la app sigue funcionando con el último
 * valor cacheado en localStorage — el retry sigue corriendo en background.
 * Al recuperar la conexión, `settingsSyncing` vuelve a false y el banner
 * desaparece automáticamente.
 */
import React from 'react';
import { RefreshCw } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const SettingsSyncBanner = () => {
  const { settingsSyncing } = useAuth();
  if (!settingsSyncing) return null;
  return (
    <div
      className="fixed bottom-16 sm:bottom-4 left-1/2 -translate-x-1/2 z-[100] pointer-events-none"
      role="status"
      aria-live="polite"
      data-testid="settings-sync-banner"
    >
      <div className="bg-amber-500/95 backdrop-blur-md text-white shadow-lg rounded-full px-4 py-1.5 flex items-center justify-center gap-2 text-xs font-semibold">
        <RefreshCw size={12} className="animate-spin" />
        <span>Sincronizando últimos precios…</span>
      </div>
    </div>
  );
};

export default SettingsSyncBanner;
